module.exports = __webpack_public_path__ + "img/marissa-600x600.5e5c4406.png";